export default function AffiliateDisclosure() {
  return (
    <div className="border-l-2 border-[#B4533C] bg-[#EFECE5] text-xs font-mono uppercase tracking-wider text-[#4A4742] px-4 py-3 my-8" data-testid="affiliate-disclosure">
      Advertiser disclosure · Some links in this article are affiliate links. JetsetLess may earn a commission if you apply, at no cost to you. Our editorial decisions remain independent.
    </div>
  );
}
